import clsx from 'clsx';
import { bool, func, node, string } from 'prop-types';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components';
import { useDelayUnmount } from 'hooks';

import 'assets/styles/components/base/dialog/_modal.scss';

const Modal = ({
  isOpen,
  body,
  onClose = null,
  header = null,
  headerHidden = false,
  footer = null,
  onClickOutside = null,
  size = 'small'
}) => {
  const { t } = useTranslation();

  /*
   * Modal is not mounted when it is closed, so we need to delay the unmounting in order to see the animation
   */
  const { showElement, mountedStyle, unmountedStyle } = useDelayUnmount(isOpen, 100);

  return createPortal(
    <>
      {showElement && (
        <div className="fixed inset-0 z-50">
          <div
            className={clsx(showElement && 'modal-overlay')}
            onClick={() => (onClickOutside ? onClickOutside() : onClose && onClose())}
          ></div>

          <div className={clsx('modal-content', size)} style={isOpen ? mountedStyle : unmountedStyle}>
            {!headerHidden && (
              <div className="modal-header">
                {header && <div>{header}</div>}

                <button type="button" className="modal-close" onClick={onClose}>
                  <Icon name="close" />
                  <span className="sr-only">{t('modals.close')}</span>
                </button>
              </div>
            )}

            <div className="modal-body">{body}</div>

            {footer && <div className="modal-footer">{footer}</div>}
          </div>
        </div>
      )}
    </>,
    document.getElementById('react-modal-portal')
  );
};

Modal.propTypes = {
  isOpen: bool.isRequired,
  body: node.isRequired,
  onClose: func,
  header: node,
  headerHidden: bool,
  footer: node,
  onClickOutside: func,
  size: string
};

export default Modal;
